module.exports = __webpack_public_path__ + "img/cross_2.ff30dd5b.png";